import { acceptObjectValue } from '../../field-viewer/shared-normalizers';
export const appointmentViewer = {
    normalizeLoadedValue: acceptObjectValue
};

//# sourceMappingURL=definition-viewer.js.map